import { createStyles } from '@mui/styles';

export const AddSignatureRequirementModalStyles = () =>
  createStyles({
    modalContent: {
      minWidth: '500px',
      padding: '24px',
    },
    formField: {
      marginBottom: '16px',
      width: '100%',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px',
      marginTop: '24px',
    },
  });
